export function backgroundUtils(screen_data){
    //rebíem casos {human:background, machine:vat}, llavors, com l'if només comprovava human, entrava al primer if i feia un return etiquetant com background. 
    //ara és més estricte, cal que ambdues etiquetes siguin a this.colors (vat/igic) no hi són: {h:background, m:total_amount}, {h:total_amount, m:background}, {h:total_amount, m:total_amount}, {h:background, m:background}  
    //si una de les dues no hi és, no entra a l'if, i si és vat o igic, entra al segon if: {h:_vat/igic, m:_vat/igic}, {h:background, m:_vat/igic}, {h:_vat/igic, m:background} etiquetant groc

    if(screen_data.annotation.label['human'] in screen_data.colors && screen_data.annotation.label['machine'] in screen_data.colors){ //una altra opció hagués sigut comprovar que machine no fora vat/igic. apagaria aquest foc.
        //console.log(screen_data.annotation.label)
        return screen_data.colors[screen_data.annotation.label['human']] 
    }

    if( screen_data.annotation.label['human'].includes('vat_') || screen_data.annotation.label['machine'].includes('vat_') || 
        screen_data.annotation.label['human'].includes('igic_')|| screen_data.annotation.label['machine'].includes('igic_')){
        //console.log("vat/igic", screen_data.annotation.label)
        return 'yellow'
    }
    return '#CCCCCC'
    }